import { render, staticRenderFns } from "./NavigationTab.vue?vue&type=template&id=c2abc762&scoped=true"
import script from "./NavigationTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NavigationTab.vue?vue&type=style&index=0&id=c2abc762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2abc762",
  null
  
)

export default component.exports